export default __webpack_public_path__ + "static/media/photo.a4ec74fa.svg";